import { BASE_URL_API } from "constants/base-url-api";
import { getCookie, removeCookie } from "utils/functions-cookie";

export interface Root {
  id: string
  name: string
  email: string
  cpf: string
  birth_date: string
  phone: string
  address: Address | null
  company: Company | null
  subscription: Subscription | null
  wallet: Wallet
  employee: Employee | null
  detail?: string 
}

export interface Address {
  street: string
  number: string
  complement: string
  neighborhood: string
  city: string
  state: string
  cep: string
}

export interface Company {
  name: string
  trading_name: string
  default_share_value: number
}

export interface Subscription {
  monthly_value: number
  plan_name: string
  starts_at: string
  ends_at: string
  blocked_until: string | null
  cancelled_at: string | null
  active: boolean
  recurrent_payment_id: string
}

export interface Wallet {
  balance: number
  is_card_token: boolean
}

export interface Employee {
  share_value: number
  name: string
  email: string
}

export const getProfile = async () => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }

  const response = await fetch(`${BASE_URL_API}/me`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
  });

  const { detail, ...userData } = (await response.json()) as Root;

  if (response.status === 403) {
    removeCookie("auth_token");
    window.location.reload()
  }

  if (response.status !== 200) {
    throw new Error(detail);
  }

  return userData;
};
